/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentCount } from '../../models/student-count';

export interface IlsControllerCountStudentsInIls$Params {
  ilsId: string;
}

export function ilsControllerCountStudentsInIls(http: HttpClient, rootUrl: string, params: IlsControllerCountStudentsInIls$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentCount>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerCountStudentsInIls.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentCount>;
    })
  );
}

ilsControllerCountStudentsInIls.PATH = '/ils/{ilsId}/studentCount';
